import { useEffect, useState } from 'react';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import arabic from 'react-date-object/calendars/arabic';
import arabic_ar from 'react-date-object/locales/arabic_en';
import ViewItems from './ViewItems';
import Text from './Text';
import { cn } from '../utils/utils';
import { fontSizes, COLORS } from '../constants/constants';
import { ErrorText } from '../pages/CorporateForm/components';

const HijriDatePicker = ({
  label,
  errorMessage,
  isRequired = false,
  labelColor,
  placeholder = 'YYYY/MM/DD (Hijri)',
  width = 'w-full',
  onChange,
  selectedDate,
  minDate,
  maxDate,
  className,
  labelDivClass,
  isLabelHeight = false,
}) => {
  const [value, setValue] = useState(selectedDate ? new DateObject({ calendar: arabic, date: selectedDate }) : null);

  useEffect(() => {
    if (selectedDate) {
      setValue(new DateObject({ calendar: arabic, date: selectedDate }));
    }
  }, [selectedDate]);

  const handleChange = (val) => {
    if (onChange) {
      onChange(val ? val : null);
    }
  };

  return (
    <ViewItems className={cn(width, className)}>
      {label && (
        <div className={cn(labelDivClass ? labelDivClass : isLabelHeight ? 'md:h-9' : "h-6")} >
          <Text text={label} size={fontSizes.h14} color={errorMessage ? 'text-red-500' : labelColor} isRequired={isRequired} className={cn('leading-4', isLabelHeight && 'mb-1')} isTruncate={false} />
        </div>
      )}
      <div className={cn('border w-full rounded-md py-1 px-2', errorMessage ? 'border-red-600' : 'border-border')}>
        <DatePicker
          value={value}
          onChange={(_, hijriDate) => {
            handleChange(hijriDate?.validatedValue?.toString() ?? '');
          }}
          calendar={arabic}
          locale={arabic_ar}
          currentDate={new DateObject({ calendar: arabic })}
          minDate={minDate ? new DateObject({ calendar: arabic, date: minDate }) : undefined}
          maxDate={maxDate ? new DateObject({ calendar: arabic, date: maxDate }) : undefined}
          placeholder={placeholder}
          inputClass='w-full py-2 px-3 border rounded-md outline-none text-sm'
          containerClassName='custom-hijri-calendar w-full'
          className='w-full'
          style={{
            height: '30px',
            border: 'none',
            outline: 'none',
            fontSize: '14px',
            padding: '5px',
            color: value ? COLORS?.neutral_grey : '',
          }}
          mapDays={({ date, today }) => {
            let props = {};
            if (today.day === date.day) {
              props.className = 'today-highlight';
            }
            return props;
          }}
        />
      </div>

      <ErrorText text={errorMessage} />
    </ViewItems>
  );
};

export default HijriDatePicker;
